  window.addEventListener('load', function () {
    var template = "{{template}}";
    console.log(template);

    function getCookieValue(name) {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim();
        if (c.indexOf(name + '=') === 0) {
          return decodeURIComponent(c.substring(name.length + 1));
        }
      }
      return '';
    }

    function setCookie(name, value, days) {
      if (!value) return;
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
    }

    function saveUtmParamsToCookies() {
      var params = new URLSearchParams(window.location.search);

      var utmParams = {
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_id: params.get('utm_id') || '',
        utm_term: params.get('utm_term') || '',
        utm_content: params.get('utm_content') || ''
      };

      Object.keys(utmParams).forEach(function (key) {
        if (utmParams[key]) {
          setCookie(key, utmParams[key], 90);
        }
      });
    }

    // UPDATED: now accepts a cookieName parameter so it can be called
    // for both the web-side GA4 stream and the server-side GA4 stream.
    function getSessionIdFromGaCookie(cookieName) {
      function parseGoogleStreamCookie(str) {
        var mapping = {
          s: "sessionId",
          o: "sessionNumber",
          g: "sessionEngaged",
          t: "lastHitTimestamp",
          j: "joinTimer",
          l: "enhancedUserIdLoggedInState",
          h: "enhancedUserId",
          d: "joinId"
        };

        var parts = str.split('.');
        var result = {};
        if (parts.length < 3) return result;

        var version = parts[0];
        if (version === 'GS1') {
          var values = parts.slice(2);
          var keys = ['s', 'o', 'g', 't', 'j', 'l', 'h', 'd'];
          for (var i = 0; i < keys.length; i++) {
            result[mapping[keys[i]]] = values[i] || '';
          }
        } else {
          var segments = parts[2].replace(/%24/g, '$').split('$');
          for (var j = 0; j < segments.length; j++) {
            var prefix = segments[j][0];
            var value = decodeURIComponent(segments[j].slice(1));
            var key = mapping[prefix] || prefix;
            result[key] = value;
          }
        }

        return result;
      }

      var cookies = document.cookie.split(';');
      var ga4Cookie = cookies.find(function (c) {
        return c.trim().startsWith(cookieName);
      });

      if (!ga4Cookie) return null;

      var cookieValue = ga4Cookie.split('=')[1].trim();
      var parsed = parseGoogleStreamCookie(cookieValue);
      return parsed.sessionId || null;
    }

    saveUtmParamsToCookies();

    var _ga = getCookieValue('_ga');
    var client_id = _ga ? _ga.substr(6) : '';
    var _gcl_aw = getCookieValue('_gcl_aw');
    var _fbp = getCookieValue('_fbp');
    var _fbc = getCookieValue('_fbc');

    // Web-side GA4 stream (G-42HVFW4QLT) → session_id
    var session_id        = getSessionIdFromGaCookie('_ga_EF72G0M16T');
    // Server-side GA4 stream (G- W02LKJNWGH) → server_session_id
    var server_session_id = getSessionIdFromGaCookie('_ga_YPW4YGSK0K');

    var utm_source = getCookieValue('utm_source');
    var utm_medium = getCookieValue('utm_medium');
    var utm_campaign = getCookieValue('utm_campaign');
    var utm_id = getCookieValue('utm_id');
    var utm_term = getCookieValue('utm_term');
    var utm_content = getCookieValue('utm_content');

    var customer_id = window.Shopify && window.Shopify.customer ? window.Shopify.customer.id : null;

    var newAttributes = {};

    function addAttr(key, value) {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        newAttributes[key] = value;
      }
    }

    addAttr('customer_id',       customer_id || 'guest');
    addAttr('_fbp',              _fbp);
    addAttr('_fbc',              _fbc);
    addAttr('_ga',               client_id);
    addAttr('_gcl_aw',           _gcl_aw);
    addAttr('session_id',        session_id);
    addAttr('server_session_id', server_session_id);
    addAttr('utm_source',        utm_source);
    addAttr('utm_medium',        utm_medium);
    addAttr('utm_campaign',      utm_campaign);
    addAttr('utm_id',            utm_id);
    addAttr('utm_term',          utm_term);
    addAttr('utm_content',       utm_content);

    if (Object.keys(newAttributes).length === 0) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var existingAttributes = cart.attributes || {};
        var mergedAttributes   = Object.assign({}, existingAttributes);
        var changed = false;

        Object.keys(newAttributes).forEach(function (key) {
          if (mergedAttributes[key] !== newAttributes[key]) {
            mergedAttributes[key] = newAttributes[key];
            changed = true;
          }
        });

        if (!changed) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: mergedAttributes
          }),
        });
      })
      .then(response => {
        if (response) return response.json();
      })
      .then(data => {
        if (data) console.log('Cart attributes updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart attributes:', error);
      });
  });